import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAward, faGraduationCap, faSchool} from "@fortawesome/free-solid-svg-icons";


const Studies = () =>{
    const {t} = useTranslation();

    const iconWrapper = "mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full " +
        "bg-accentSoft text-accent dark:bg-accent/15"

    return (
        <ul className={"space-y-4"}>
            <li className={"flex gap-3"}>
                <span className={iconWrapper}>
                    <FontAwesomeIcon icon={faGraduationCap}/>
                </span>
                <div>
                    <p className={"font-semibold"}>{t('studies.uni')}</p>
                    <p className={"mt-0.5 text-sm text-mutedLight dark:text-mutedDark sm:text-base"}>
                        <FontAwesomeIcon icon={faAward} className={"mr-1.5 text-amber-500"}/>
                        {t('studies.tfgM')}
                    </p>
                </div>
            </li>
            <li className={"flex gap-3"}>
                <span className={iconWrapper}>
                    <FontAwesomeIcon icon={faSchool}/>
                </span>
                <p className={"font-semibold pt-1.5"}>{t('studies.bach')}</p>
            </li>
        </ul>
    )
}

export default Studies
